'use strict';

var _ = require('lodash');
var CompetitorFaresTooltipService = function CompetitorFaresTooltipService() {
  var SPLITTING_DATA_RULES = [{
    totalElements: 15,
    maxElementsAtColumn: 5
  }, {
    totalElements: 31,
    maxElementsAtColumn: 8
  }];
  function splitDataToColumns(data) {
    var maxElementsAtColumn = 16;
    var dataPointsLength = data.length;
    for (var i = 0; i < SPLITTING_DATA_RULES.length; i++) {
      if (dataPointsLength <= SPLITTING_DATA_RULES[i].totalElements) {
        return _.chunk(data, SPLITTING_DATA_RULES[i].maxElementsAtColumn);
      }
    }
    return _.chunk(data, maxElementsAtColumn);
  }
  return {
    splitDataToColumns: splitDataToColumns
  };
};
CompetitorFaresTooltipService.$inject = [];
module.exports = CompetitorFaresTooltipService;